import { TextOrHTML } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { FlattenedSectionProps } from ".";
import {
  getSuggestedQuestions,
  getVisibleQuestions,
  useCoverGeniusSection,
} from "../../../hooks/useCoverGeniusSection";
import { useCoverGeniusSeeMoreCoversState } from "../../../hooks/useCoverGeniusSeeMoreCoversState";
import { getVerticalFromPreambleName, Insurers } from "./Insurers";
import { Question } from "./Question";
import { isQuestion } from "./Question/types";

export const CoverGeniusSection = ({
  ref,
  ...props
}: FlattenedSectionProps) => {
  const { title, preamble, postamble, preambleName, questions, className } =
    props;
  const classes = classNames("mobius", "mobius-section", className);
  const showInsurers = getVerticalFromPreambleName(preambleName);
  const visiblySuggestedQuestions = getVisibleQuestions(questions);
  const visibleQuestions = getSuggestedQuestions(questions);
  const allQuestions =
    visibleQuestions.length > 0 ? visibleQuestions : questions;
  const [showSeeMoreCoversTrigger] = useCoverGeniusSeeMoreCoversState();
  const coverGeniusQuestions = showSeeMoreCoversTrigger
    ? visiblySuggestedQuestions
    : allQuestions;

  useCoverGeniusSection({
    allQuestions: questions,
  });

  return (
    <section data-testid="mobius-section" ref={ref} className={classes}>
      {title && <h2 className="mobius-section__title">{title}</h2>}
      {showInsurers && <Insurers insurersLogosSet={showInsurers} />}
      {preamble && (
        <TextOrHTML
          className="mobius-section__preamble"
          text={preamble}
          textWrapper
        />
      )}
      <div className="mobius-section__question-container">
        {coverGeniusQuestions.filter(isQuestion).map(question => (
          <Question key={question.name} {...question} />
        ))}
      </div>
      {postamble && (
        <TextOrHTML
          className="mobius-section__postamble"
          text={postamble}
          textWrapper
        />
      )}
    </section>
  );
};

CoverGeniusSection.displayName = "Section";
